import { RootState } from '@/bootstrap/redux'

export const selectUIMessages = (state: RootState) => state.uimessages.messages